import { render, staticRenderFns } from "./AnotherBrowser.vue?vue&type=template&id=206f68be"
import script from "./AnotherBrowser.vue?vue&type=script&lang=ts"
export * from "./AnotherBrowser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports